import { render, staticRenderFns } from "./editBrand.vue?vue&type=template&id=2c38dc64&"
import script from "./editBrand.vue?vue&type=script&lang=js&"
export * from "./editBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports